import { Action } from 'redux'
import { ConfigurationModalActions } from '../../../reducers/bookingCalendar/actionNames'

const ToggleCreateModal = (toggle = true): IToggleCreate => ({
  showModal: toggle,
  type: ConfigurationModalActions.ToggleCreateModal,
})

export { ToggleCreateModal }

export interface IToggleCreate
  extends Action<ConfigurationModalActions.ToggleCreateModal> {
  showModal: boolean
}
